import React from "react";
import { Options } from "../Components";

export const PrintShippingLabel = () => {
  return <Options />;
};
